import moment from 'moment';
import _ from 'lodash';
import { LANGUAGE_ZH_HK } from '../comm/config';
import { i18n } from '../language';

const MONTH_SELECT_DATE = 'DAY_OF_MONTH';
const MONTH_N_TH_DAY_OF_WEEK = 'NTH_DAY_OF_WEEK';
const MONTH_SECOND_TO_LAST_DAY_OF_WEEK = 'SECOND_TO_LAST_DAY_OF_WEEK';
const MONTH_LAST_DAY_OF_WEEK = 'LAST_DAY_OF_WEEK';
const MONTH_LAST_DAY = 'END_OF_MONTH';

const getWeekDisplayName = (dayOfWeek) => {
  const weekNameMap = {
    1: {
      en: 'Monday',
      zh: '星期一',
    },
    2: {
      en: 'Tuesday',
      zh: '星期二',
    },
    3: {
      en: 'Wednesday',
      zh: '星期三',
    },
    4: {
      en: 'Thursday',
      zh: '星期四',
    },
    5: {
      en: 'Friday',
      zh: '星期五',
    },
    6: {
      en: 'Saturday',
      zh: '星期六',
    },
    7: {
      en: 'Sunday',
      zh: '星期日',
    },
  };
  const currentLang = (i18n.locale ?? '').toLowerCase();
  const dayName = weekNameMap?.[Number(dayOfWeek)];

  if (!dayName) {
    return '';
  }

  return currentLang === LANGUAGE_ZH_HK ? dayName.zh : dayName.en;
};

const getOrdinalDisplayValue = (value) => {
  const currentLang = (i18n.locale ?? '').toLowerCase();
  const numberVal = Number(value);

  if (!Number.isFinite(numberVal)) {
    return value;
  }

  if (currentLang === LANGUAGE_ZH_HK) {
    return numberVal;
  }

  const absVal = Math.abs(numberVal);
  const mod100 = absVal % 100;

  if (mod100 >= 11 && mod100 <= 13) {
    return `${numberVal}th`;
  }

  switch (absVal % 10) {
    case 1:
      return `${numberVal}st`;
    case 2:
      return `${numberVal}nd`;
    case 3:
      return `${numberVal}rd`;
    default:
      return `${numberVal}th`;
  }
};

const getTaskRepeatLable = (postday, customRecurrenceConfig) => {
  const { intervalType, intervalValue, endDate, monthRepeatType, daysOfWeek } = customRecurrenceConfig;

  if (intervalType === 'DAY') {
    return `(${i18n.t('EHANDOVER_DAY_LABEL', { num: intervalValue, endDate: moment(endDate).format('yyyy-MM-DD') })})`;
  }

  if (intervalType === 'WEEK') {
    let weeks = '';
    weeks = _.map([...(daysOfWeek ?? [])].sort((a, b)=> Number(a) - Number(b)), (item) => getWeekDisplayName(item));
    return `(${i18n.t('EHANDOVER_WEEK_LABEL', {
      num: intervalValue,
      weeks: weeks.join(', '),
      endDate: moment(endDate).format('yyyy-MM-DD'),
    })})`;
  }

  if (intervalType === 'MONTH') {
    const rules = checkDateForRules(postday);

    return `(${i18n.t('EHANDOVER_MONTH_LABEL', {
      repeatType: monthRepeatType === 'END_OF_MONTH' ? i18n.t('EHANDOVER_REPEAT_AT') : i18n.t('EHANDOVER_REPEAT_ON'),
      monthRepeatType: rules?.[monthRepeatType]?.optionText,
      num: intervalValue,
      endDate: moment(endDate).format('yyyy-MM-DD'),
    })})`;
  }
};

const checkDateForRules = (date) => {
  const momentDate = moment(date);
  const nthDayOfWeek = Math.ceil(momentDate.date() / 7);
  let result = {
    DAY_OF_MONTH: {
      recurrenceType: MONTH_SELECT_DATE,
      dayOfMonth: momentDate.date(),
      optionText: i18n.t('EHANDOVER_MONTH_SELECT_DATE', {
        dayOfMonth: getOrdinalDisplayValue(momentDate.date()),
      }),
    },
  };

  if (nthDayOfWeek < 5) {
    result.NTH_DAY_OF_WEEK = {
      recurrenceType: MONTH_N_TH_DAY_OF_WEEK,
      nthDayOfWeek: nthDayOfWeek,
      dayOfWeek: momentDate.isoWeekday(),
      optionText: i18n.t('EHANDOVER_MONTH_N_TH_DAY_OF_WEEK', {
        nthDayOfWeek: getOrdinalDisplayValue(nthDayOfWeek),
        dayOfWeek: getWeekDisplayName(momentDate.isoWeekday()),
      }),
    };
  }

  if (momentDate.date() <= momentDate.daysInMonth() - 7 && momentDate.date() >= momentDate.daysInMonth() - 14) {
    result.SECOND_TO_LAST_DAY_OF_WEEK = {
      recurrenceType: MONTH_SECOND_TO_LAST_DAY_OF_WEEK,
      dayOfWeek: momentDate.isoWeekday(),
      optionText: i18n.t('EHANDOVER_MONTH_SECOND_TO_LAST_DAY_OF_WEEK', {
        dayOfWeek: getWeekDisplayName(momentDate.isoWeekday()),
      }),
    };
  }

  if (momentDate.date() > momentDate.daysInMonth() - 7) {
    result.LAST_DAY_OF_WEEK = {
      recurrenceType: MONTH_LAST_DAY_OF_WEEK,
      dayOfWeek: momentDate.isoWeekday(),
      optionText: i18n.t('EHANDOVER_MONTH_LAST_DAY_OF_WEEK', {
        dayOfWeek: getWeekDisplayName(momentDate.isoWeekday()),
      }),
    };
  }

  if (momentDate.date() === momentDate.daysInMonth()) {
    result.END_OF_MONTH = {
      recurrenceType: MONTH_LAST_DAY,
      optionText: i18n.t('EHANDOVER_MONTH_LAST_DAY', {}),
    };
  }

  return result;
};

export { checkDateForRules, getWeekDisplayName, getOrdinalDisplayValue, getTaskRepeatLable };
